import { Clock } from "lucide-react";

export default function TimeBadge({ hours, size = "md", testId = "time-badge" }) {
  const formatted = Number(hours || 0).toFixed(Number.isInteger(Number(hours)) ? 0 : 1);
  const cls =
    size === "lg"
      ? "px-4 py-1.5 text-base"
      : size === "sm"
        ? "px-2.5 py-0.5 text-xs"
        : "px-3 py-1 text-sm";
  return (
    <span data-testid={testId} className={`time-badge ${cls}`}>
      <Clock className="h-3.5 w-3.5" strokeWidth={2.5} />
      {formatted} {Number(formatted) === 1 ? "hr" : "hrs"}
    </span>
  );
}
